import WidgetModule from "@eisinc/Overrides/Widgets/ChangeCustomer/ChangeCustomerShipToSelector";

export * from "@eisinc/Overrides/Widgets/ChangeCustomer/ChangeCustomerShipToSelector";

export default WidgetModule;
